module.exports = __webpack_public_path__ + "img/amazon-ae.258947cc.png";